import { useEffect, useState } from "react";
import { useLogin } from "../../hook/partner/authentication/login.partner.hook";
import { useAuthStore } from "../../store/auth.store";
import { useMe } from "../../hook/partner/authentication/me.partner.hook";
import { NavLink } from "react-router";
import { useTranslation } from "../../hooks/useTranslation";

function Login() {
  const { t } = useTranslation();
  useEffect(() => {
    window.document.body.classList.add("auth-bg");
  }, []);

  const [username, setUsername] = useState(""); //pavel@janda.it 822019 +784115
  const [specificatedPerson, setSpecificatedPerson] = useState(); // 822019
  const [password, setPassword] = useState(""); // hesloh
  const [code2fa, setCode2fa] = useState(""); // 990774
  //const [requires2fa, setRequires2fa] = useState(false);

  const token = useAuthStore((state) => state.token);
  const specifyPerson = useAuthStore((state) => state.specifyPerson);
  const requires2fa = useAuthStore((state) => state.requires2fa);
  const error = useAuthStore((state) => state.error);

  const loginMutation = useLogin();
  const meMutation = useMe();

  useEffect(() => {
    if (specificatedPerson) {
      handleSubmit();
    }
  }, [specificatedPerson]);

  const handleSubmit = (e) => {
    e?.preventDefault();

    let usernameValue = username;

    if (specificatedPerson) {
      usernameValue += "+" + specificatedPerson;
    }

    loginMutation.mutate(
      { username: usernameValue, password, code2fa },
      {
        onSuccess: (data) => {
          if (data.token) {
            meMutation.mutate(data.token, {
              onSuccess: (data) => {
                console.log(data);
              },
            });
          }
        },
      }
    );
  };
  return (
    <>
      <div className="d-flex flex-column flex-lg-row flex-column-fluid">
        <div className="d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1">
          <div className="d-flex flex-center flex-column flex-lg-row-fluid">
            <div className="w-lg-500px p-10 card">
              <form
                onSubmit={handleSubmit}
                className="form w-100"
                noValidate="novalidate"
                id="kt_sign_in_form"
                data-kt-redirect-url="index.html"
                action="#"
              >
                <div className="text-center mb-11">
                  <img src="/assets/media/logo-exn.png" />
                  <h1 className="text-gray-500 fw-bolder mb-3 mt-6">
                    {t("auth.login")}
                  </h1>
                </div>

                {loginMutation.isError && (
                  <p className="text-danger">{loginMutation.error.message}</p>
                )}

                {error && (
                  <div className="fv-row mb-8">
                    <div className="alert alert-info mb-5 fs-5 fw-bold text-center">
                      {error}
                    </div>
                  </div>
                )}

                {!(specifyPerson || requires2fa) && (
                  <>
                    <div className="fv-row mb-8">
                      <input
                        type="text"
                        placeholder={t("users.email")}
                        name="email"
                        autoComplete="off"
                        defaultValue={username}
                        onChange={(e) => setUsername(e.target.value)}
                        disabled={requires2fa}
                        className="form-control xbg-transparent"
                      />
                    </div>
                    <div className="fv-row mb-3">
                      <input
                        type="password"
                        placeholder={t("auth.password")}
                        name="password"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        autoComplete="off"
                        className="form-control xbg-transparent"
                      />
                    </div>
                  </>
                )}
                {specifyPerson && !specificatedPerson && (
                  <div className="fv-row mt-8 mb-3">
                    <select
                      className="form-control form-select xbg-transparent"
                      onChange={(e) => setSpecificatedPerson(e.target.value)}
                    >
                      <option>--- {t("auth.selectSpecificPerson")} ---</option>
                      {specifyPerson.map((person) => (
                        <option key={person.person_id} value={person.person_id}>
                          {person.first_name +
                            " " +
                            person.last_name +
                            " (" +
                            person.company_name +
                            ")"}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
                {requires2fa && (
                  <div className="fv-row mb-3 mt-8">
                    <input
                      placeholder={t("auth.verificationCode")}
                      name="code2fa"
                      autoComplete="off"
                      type="text"
                      id="code2fa"
                      value={code2fa}
                      onChange={(e) => setCode2fa(e.target.value)}
                      className="form-control xbg-transparent"
                    />
                  </div>
                )}
                <div className="d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8">
                  <div>
                    <NavLink to={"/zapomenute-heslo"} className="link-primary">
                      {t("auth.forgotPassword")}?
                    </NavLink>{" "}
                    |{" "}
                    <NavLink to={"/registrace"} className="link-primary">
                      {t("auth.userRegistration")}
                    </NavLink>
                  </div>
                </div>
                <div className="d-grid mb-10">
                  <button
                    type="submit"
                    id="kt_sign_in_submit"
                    className="btn btn-primary"
                    disabled={loginMutation.isLoading}
                  >
                    {loginMutation.isLoading ? (
                      <span className="indicator-label">
                        {t("auth.loggingIn")}
                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>
                    ) : (
                      <span className="indicator-label">{t("auth.signIn")}</span>
                    )}
                  </button>
                </div>
                <div className="text-gray-500 text-center fw-semibold fs-6 d-none">
                  {t("auth.noAccount")}&nbsp;
                  <a
                    href="authentication/layouts/corporate/sign-up.html"
                    className="link-primary"
                  >
                    {t("auth.register")}
                  </a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
